import { render, staticRenderFns } from "./AvatarUser.vue?vue&type=template&id=3df9d6f2&scoped=true&"
import script from "./AvatarUser.vue?vue&type=script&lang=js&"
export * from "./AvatarUser.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUser.vue?vue&type=style&index=0&id=3df9d6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df9d6f2",
  null
  
)

export default component.exports